var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"item"},[_vm._v("© 2017-"+_vm._s(_vm.curYear)+" 杭州亿尚智能科技有限公司 版权所有 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }